export * from './types';
export * from './ColorChips';
export * from './BasicColorPallete';
export * from './BasicColorPicker';
export * from './CustomColorPicker';
export * from './utils/ColorPickerUtil';
export * from './hooks/useColorValidationAdapter';
export * from './hooks/useCustomColorPickerA11yInfo';
export * from './hooks/useHexBidiFormatter';
export * from './dataProviders/ColorPickerDataProvider';
export * from './hooks/useColorPickerDimensions';
export const EMPTY_CHIP_COLOR = 'transparent';
export let recentStandardColors = Array(7).fill(EMPTY_CHIP_COLOR);
export function setRecentStandardColors(colors) {
  recentStandardColors = colors;
}
//# sourceMappingURL=index.js.map